import s from './styles.module.scss'

type Props = {
  isActive?: boolean
  onChange?: () => void
  readonly?: boolean
  disabled?: boolean
}

export const RadioButton = ({
  isActive,
  onChange,
  readonly,
  disabled,
}: Props) => {
  return (
    <label className={s.customRadio}>
      <input
        type="radio"
        className={s.customRadioInput}
        checked={isActive}
        onChange={onChange}
        readOnly={readonly}
        disabled={disabled}
      />
      <span className={s.customRadioCircle}></span>
    </label>
  )
}
